import { defineStore } from 'pinia'

export const isLoader = defineStore('loadzory', {
    state: () => {
        return { loadzory: false }
    },
    actions: {
        get() {
            return this.loadzory
        },
        set(value) {
            this.loadzory = value
        }
    },
})